<template>
    <Layout>
        <PageHeader :title="title" :items="items"/>
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-12 text-right">
                        <modalCadastro @update="listAllUsers" :item="{ uid : 'novo', email :'' }"></modalCadastro>
                        <br>
                        <br>
                    </div>
                    <div class="col-12">
                        <b-overlay :show="is_load">
                            <b-table :fields="colunas" :items="dados" class="table table-striped">
                                <template v-slot:cell(metadata.creationTime)="data">
                                    {{ formatDate(data.item.metadata.creationTime) }}
                                </template>
                                <template v-slot:cell(metadata.lastSignInTime)="data">
                                    {{ formatDate(data.item.metadata.lastSignInTime) }}
                                </template>
                                <template v-slot:cell(botao)="data">
                                    <modalCadastro @update="listAllUsers" :item="data.item"></modalCadastro>
                                    <button style="margin-left: 10px" @click="removerUsuario(data.item)" class="btn btn-danger"><i class="fa fa-trash"></i></button>

                                </template>
                                <template v-slot:cell(name)="data">
                                    <a class="btn btn-sm btn-success" :href="url_vindi+'admin/plans/'+data.item.id" target="_blank"><i class="dripicons-link"></i> vindi</a> {{ data.item.name }}
                                </template>
                                <template v-slot:cell(produtos)="data">

                                   <span v-if="data.item.plan_items">
                                        <span v-for="(item,index) in data.item.plan_items" :key="item.id">
                                           <span v-if="index>0">, </span> <a class="btn btn-sm btn-success" :href="url_vindi+'admin/products/'+item.product.id" target="_blank"><i class="dripicons-link"></i> vindi</a>  {{ item.product.name }}
                                        </span>
                                   </span>
                                </template>
                                <template v-slot:cell(contador)="data">
                                    {{ data.index + 1 }}
                                </template>
                            </b-table>
                        </b-overlay>
                    </div>
                </div>
            </div>
        </div>

    </Layout>
</template>

<script>

import Layout from "../layouts/main";
import PageHeader from "@/components/page-header";
import modalCadastro from "@/components/modalCadastro";
import "firebase/auth";
import axios from "axios";
import moment from "moment";
import Vue from "vue";

export default {
    name: "admins",
    components: {
        Layout,
        PageHeader,
        modalCadastro
    },
    data() {
        return {
            is_load: false,
            dados: [],
            colunas: [
                {key: 'contador', label: ''},
                {key: 'uid', label: 'ID'},
                {key: 'email', label: 'E-mail'},
                {key: 'displayName', label: 'Nome'},
                {key: 'metadata.creationTime', label: 'Criação'},
                {key: 'metadata.lastSignInTime', label: 'Último login'},
                {key: 'botao', label: 'Ações'},
            ],
            title: "Admins",
            items: [
                {
                    text: "Home"
                },
                {
                    text: "Admins",
                    active: true
                }
            ]
        };
    },
    mounted() {
        moment.locale('pt-br');
        this.listAllUsers();
    },
    methods: {
        formatDate(val) {
            return moment(val).format('DD/MM/YYYY HH:mm:ss');
        },
        removerUsuario(user){
            window.objthis = this;
            Vue.swal({
                title: 'Você tem certeza?',
                text: "Você não poderá desfazer esta ação!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim, remover!',
                cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.value) {
                    window.objthis.is_load = true;
                    axios.delete('usuarios?uid='+user.uid ).then(() => {
                        Vue.swal({
                            title: 'Cadastro excluido com sucesso',
                            type: 'success',
                            confirmButtonText: 'Ok'
                        });
                        window.objthis.listAllUsers();
                    }).catch((error) => {
                        Vue.swal({
                            title: 'Erro ao excluir cadastro',
                            text: error.response.data.erro,
                            type: 'error',
                            confirmButtonText: 'Ok'
                        })
                    })
                }
            })
        },
        listAllUsers() {
            this.is_load = true;
            axios.get('usuarios').then(response => {
                this.dados = response.data;
                this.is_load = false;
                console.log(this.dados)
            }).catch(error => {
                this.is_load = false;
                this.dados = [];
                console.log(error)
            })
        }
    }
}
</script>

<style scoped>

</style>